import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { axiosPrivate } from '../../Helpers/axios';
import axios from 'axios';

function* getAllTransactionSaga({payload:{agentId}}) {
  try {
    const response = yield call(axiosPrivate, `${process.env.REACT_APP_RECON_API_BASE_URL}prepaid/allTransaction?agentId=${agentId ? agentId : ""}`);
    if (response.status === 200) {
      yield put(actions.getAllTransactionSuccess(response.data));
    } else {
      yield put(actions.getAllTransactionFailed(response.message));
    }
  } catch (error) {
    yield put(actions.getAllTransactionFailed(error?.response?.data?.message || 'Something went wrong'));
  }
}

function* getSuccessSummarySaga({payload:{agentId}}) {
  try {
    const response = yield call(axiosPrivate, `${process.env.REACT_APP_RECON_API_BASE_URL}prepaid/totalSuccessSummary?agentId=${agentId ? agentId: ""}`);
    if (response.status === 200) {
      yield put(actions.getSuccessSummarySuccess(response.data));
    } else {
      yield put(actions.getSuccessSummaryFailed(response.message));
    }
  } catch (error) {
    yield put(actions.getSuccessSummaryFailed(error?.response?.data?.message || 'Something went wrong'));
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.GET_ALL_TRANSACTION, getAllTransactionSaga)]);
   yield all([takeEvery(actions.GET_SUCCESS_SUMMARY, getSuccessSummarySaga)]);
  
}
